import { render } from "./DateSeparator.vue?vue&type=template&id=4cd896d9&scoped=true"
import script from "./DateSeparator.vue?vue&type=script&lang=js"
export * from "./DateSeparator.vue?vue&type=script&lang=js"

import "./DateSeparator.vue?vue&type=style&index=0&id=4cd896d9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cd896d9"]])

export default __exports__